<template>
  <div class="animated revealUp">
    <div class="d-flex align-items-center justify-content-between mb-4">
      <div class="section-title">{{ $tc('customer', 1)}} {{ $t('transactions') }}</div>
      <div class="d-flex align-items-center">
        <b-dropdown name="listview" id="listview" variant="outline-blue">
          <template v-slot:button-content>
            Viewing&nbsp;
            <strong>{{selectedvalue}}</strong>
            &nbsp;Of&nbsp;
            <strong>{{ rows }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            href="#"
          >{{list.name}}</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="white-wrapper">
      <div class="mt-3 mb-4">
        <div class="row">
          <div class="col-lg-4 col-xl-3 align-self-center">
            <div class="dropdown-curve-container mr-2">
              <!-- <button v-if="selectedFilter" v-on:click="clearFilter()" class="btn-clearDate">✖</button> -->
              <label
                :class="selectedFilter && selectedFilter.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('filter') }}</label>
              <b-dropdown
                :text="selectedFilter"
                name="selectuser"
                id="selectcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(User, UserIndex) in usersDetails"
                  :key="UserIndex"
                  v-on:click="onSelectFilter($event, User);"
                >{{ User }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div
            v-if="selectedFilter && selectedFilter.length > 0"
            class="col-lg-4 col-xl-3 align-self-center"
          >
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="filtervalue"
                  name="firstname"
                  id="firstname"
                />
                <label
                  :class="selectedFilterValue && selectedFilterValue.length > 0 ? 'shift-up' : '' "
                >{{ $t('select') }} {{selectedFilter}}</label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center">
            <button
              :disabled="btenable"
              @click.prevent.stop="onGetCustomerList"
              class="btn-blue w-100"
            >{{ $tc('Fetch User') }}</button>
          </div>
        </div>
      </div>

      <div>
        <table class="table">
          <thead class="bg-light">
            <tr>
              <th><img
              v-if="this.columnName != 'first_name'"
              @click="onSortValue('first_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('first_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('first_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            Customer Name</th>
              <th>Mobile Number</th>
              <th>Email Address</th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(customer, customerIndex) in customerList" :key="customerIndex">
              <td>{{customer.first_name?customer.first_name:"-"}} {{customer.last_name}}</td>
              <td>{{customer.cust_mobile?customer.cust_mobile:-""}}</td>
              <td>{{customer.cust_email?customer.cust_email:"-"}}</td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-link"
                  v-on:click="onSelectDetails(customer)"
                >View {{ $t('transactions') }}</button>
              </td>
            </tr>
          </tbody>
          <tbody v-if="customerList.length == 0">
            <tr>
              <td colspan="4">
                <!-- <h3 class="ml-3">{{ 'No records found' }}</h3> -->
                <NoRecords/>
              </td>
            </tr>
          </tbody>
        </table>
        <b-pagination
          v-if="customerList && customerList.length > 0"
          v-model="currentPage"
          :total-rows="rows"
          @change="onChangePagination($event)"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import UserService from "@/services/UserService";
import MovieService from "@/services/MovieService";
import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: { DatePicker, Multiselect, NoRecords },
  data() {
    return {
      btenable: false,
      filtervalue: "",
      selectedFilterValue: "",
      filterValues: [],
      selectedFilter: "",
      isRoleID: true,
      customerList: [],
      customerListCopy: [],

      selectedFilter: "",
      usersDetails: ["Customer Name","Contact Number", "Email Address"],
      fetchUserDetail: {
        date: "",
        cinema_id: null,
        ssb_code: ""
      },

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: '',
      columnName: "",

      selectedCinema: "",
      Cinemas: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ]
    };
  },
  beforeMount() {
    this.onGetCustomerList();
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
  },
  methods: {
    onSelectDetails: function(customer) {
      console.log("object :", customer);
      this.$router.push({
        path: "/cinema-manager/view-customer-transaction",
        query: {
          cust_id: customer.cust_id
        }
      });
    },
    onSelectFilter: function(event, params) {
      console.log("params :", params == "Show Booking Code");

      this.filterValues = [];
      this.filtervalue = "";
      this.selectedFilterValue = "";
      this.selectedFilter = params;
      if (params == "Contact Number") {
        this.filterkey = "cust_mobile";
      } else if (params == "Email Address") {
        this.filterkey = "cust_email";
      }else if (params == "Customer Name") {
        this.filterkey = "first_name";
      }

      //   this.onGetCustomerList();
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.onGetCustomerList();
    },

    onGetCustomerList: function() {
      this.customerList = [];

      console.log("object :", this.filterkey);
      if (
        this.filterkey &&
        this.filterkey.length > 0 &&
        this.filtervalue.length == 0
      ) {
        this.$toasted.show("Please enter filter value.");
      } else if (this.filtervalue.length > 0 && this.filterkey.length == 0) {
        this.$toasted.show("Please select filter key.");
      } else {
        this.btenable = true;
        let payload = {
          currentPage: this.currentPage,
          perPage: this.perPage,
          filterkey: this.filterkey ? this.filterkey : null,
          filtervalue: this.filtervalue ? this.filtervalue : null,
          columnName: this.columnName,
          orderBy: this.orderby,
        };
        console.log("payload :", payload);
        MasterService.getCustomerDetails(payload)
          .then(response => {
            this.btenable = false;
            const { data } = response;
            if (data.status && data.Records && data.Records.length > 0) {
              this.customerList = data.Records;
              this.customerListCopy = data.Records;
              this.rows = data.totalRows;
              if (this.rows <= this.selectedvalue) {
                this.selectedvalue = this.rows;
              }
            } else if (data.Records && data.Records.length == 0) {
              this.$toasted.show("No Records Found.");
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    },
    clearFilter: function() {
      this.selectedFilterValue = "";
      this.filterValues = [];
      this.selectedFilter = "";
      this.selectedFilterValue = "";
      this.filterkey = "";
      this.filtervalue = "";
    },
    onSelectCinema: function(event, params) {
      this.selectedCinema = params.cine_name;
      this.fetchUserDetail.cinema_id = params.cine_id;
      this.getUserList(params.cine_id);
      if (this.fetchUserDetail.date) {
        this.onGetCustomerList();
      } else {
        this.$toasted.show("Please select date");
      }
    },
    getUserList: function(cinema_Id) {
      let body = {
        limit: null,
        currentPage: null
      };
      UserService.ListAllUser({}, body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.filterValues = data.data.filter(x => {
              if (x.cinema_id == cinema_Id) {
                return x;
              }
            });
          } else if (
            data.status == false &&
            data.message == "You are not authorized"
          ) {
            this.$router.push({
              path: "/access-denied"
            });
          } else {
            this.$toasted.show(data.message);
          }
          console.log("this.users :", this.users);
        })
        .catch(this._CatchError);
    },
    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.onGetCustomerList();
      } else {
        this.currentPage = event;
        this.onGetCustomerList();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    }
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/customerTransactionComponents/customerList.vue